// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__-scmW"};